import {IIConProps} from '@common/interfaces';

export function CloseIcon({fill, width, height}: Readonly<IIConProps>) {
  return (
    <svg
      width={width ?? '12'}
      height={height ?? '12'}
      viewBox='0 0 12 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.46447 1.53553L9.53553 8.6066M9.53553 1.53553L2.46447 8.6066'
        stroke={fill ?? '#163463'}
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

CloseIcon.defaultProps = {
  fill: '#163463',
  width: '12',
  height: '12',
};
